export default "__VITE_ASSET__DtXJLv51__"